import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    size: {
      default: 56
    },
    fontSize: null
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_n_avatar = _resolveComponent("n-avatar");

      return _openBlock(), _createBlock(_component_n_avatar, {
        class: "avatar text-uppercase",
        style: _normalizeStyle({
          'width': "".concat(__props.size, "px"),
          'height': "".concat(__props.size, "px"),
          'font-size': "".concat(__props.fontSize, "px") || 'var(--n-font-size)'
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(__props.user.userName.substring(0, 2)), 1)];
        }),
        _: 1
      }, 8, ["style"]);
    };
  }
});